import React from 'react';
import { FormControl, Button ,Icon} from 'tinper-bee';
import { withRouter } from 'react-router-dom';
import './SearchWrap.less';
const imagePath = require('../../../images/search.png')
class SearchWrap extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            searchType: 'com',
            value: '',
        };
    }

    onKeyDown(e) {
        if(e.keyCode !== 13 ) return;
        this.onSearch()
    }

    seeMDF = () => {
        this.props.seeMDF && this.props.seeMDF();
    }
    onSearch = () => {
        this.props.onSearch(this.state.value);
    }

    render() {
        return (
            <div className='search-wrap'>
                <div className='search-input-wrap'>
                    <FormControl
                        onChange={(e: any) => this.setState({value: e})}
                        value={this.state.value}
                        onKeyDown={(e) => this.onKeyDown(e)}
                        placeholder='输入关键词搜索'
                    />
                    <span
                        className='search-btn'
                        onClick={this.onSearch}
                    >
                        <Icon style={{fontSize: 18}} type="uf-search" />
                        搜索
                    </span>
                </div>
            </div>
        );
    }
}

export default withRouter(SearchWrap);
